import React, { useEffect, useState } from "react";
import "./css/CourseCategory.css";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import categories from "./Categories";
import { MoneyOff } from "@material-ui/icons";

const CourseCategory = () => {
  const [singleCate, setSingleCate] = useState([]);
  const [cate, setCate] = useState(categories[0].content);
  let cateData;

  useEffect(() => {
    setSingleCate(categories);
  }, []);

  const handleCategory = (id, content) => {
    // console.log(id);
    cateData = categories.filter((cd) => cd.id === id);
    cateData.map((data) => {
      setCate(data.content);
    });
  };

  //console.log(cate);

  // singleCate.map((category) => {
  //   let cateData = categories.filter((cd) => cd.id === id);

  // });

  return (
    <div className="course-category">
      <div className="course-category-main">
        <div className="course-category-select">
          <p>Select your category</p>

          <div className="course-category-options">
            {singleCate.map((data) => (
              <div
                onClick={() => handleCategory(data.id, data.content)}
                className="course-category-option"
              >
                <p>{data.name}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="course-categories-course">
          {cate.map((data) => (
            <div className="course-category-cards">
              <div className="course-category-card">
                <div className="course-category-card-container">
                  <p>{data.category}</p>
                  <div className="course-category-info">
                    <p>Learn</p>
                    <p>{data.learn}</p>
                  </div>
                  <div className="course-category-info">
                    <p>Implement</p>
                    <p>{data.implement}</p>
                  </div>
                  <div className="course-category-info">
                    <p className="link">See Curriculum</p>
                  </div>
                  <div className="course-category-button">
                    <button
                      onClick={() =>
                        (window.location.href = `/course?name=${data.name.toLowerCase()}&id=${
                          data._id
                        }&category=${data.category.toLowerCase()}&paid=${
                          data.paid
                        }`)
                      }
                    >
                      {data.paid ? "Paid" : "Start Free"}
                    </button>
                    {data.paid ? <AttachMoneyIcon /> : <MoneyOff />}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CourseCategory;
